<template>
  <div class="schedule">
    <div v-for="(day, index) in scheduleData" :key="day.dayWeek">
      <div class="day-title" :class="{'is-today':(index + 1) === today}">
        <div class="time">
          <span class="day-date">{{ day.date }}</span>
          <span class="day-slash">/</span>
          <span class="day-month">{{ day.month }}</span>
        </div>
        <div class="day-week">
          <span>{{ day.dayWeek }}</span>
        </div>
      </div>
      <div class="day-events" :class="{'is-today':(index + 1) === today}">
        <morning-plan :plan-data="day.events?.morning" @clickChangePlan="clickChange"/>
        <night-plan :plan-data="day.events?.night" @clickChangePlan="clickChange"/>
        <midnight-plan :plan-data="day.events?.midnight" @clickChangePlan="clickChange"/>
      </div>
    </div>
    <my-dialog
      :width="452"
      form-title="编辑"
      :dialog-carted="isShowEditDialog"
      confirm-button="确定"
      @confirmOk="dealEditDialog"
    >
      <template #content>
        <div>
          <div class="line-one">
            <span>科室</span>
            <el-select
              v-model="form.room"
              placeholder="-------"
              @change="changeRoomValue"
            >
              <el-option
                v-for="item in roomOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <div class="line-two">
            <div
              v-for="(person) in persons"
              :key="person.id"
              class="person"
              :class="{'is-selected': selectId.includes(person.id)}"
              @click="clickOne(person)"
            >
              <div class="image-body"/>
              <span>{{ person.value }}</span>
            </div>
          </div>
          <div class="line-three">
            <span>已选: </span>
            <span>{{ showSelectNames.join("，") }}</span>
          </div>
        </div>
      </template>
    </my-dialog>
  </div>
</template>

<script>
import MyDialog from "@components/customDialog/MyDialog";
import { showWindowMessage } from "@utils/notification";
import { getDepartUser, saveWeekPlan } from "@api/user";
import scheduleTool from "@views/SettingSchedule/scheduleTool.js";
import MorningPlan from "@components/setting/TimeControl/MorningPlan";
import MidnightPlan from "@components/setting/TimeControl/MidnightPlan";
import NightPlan from "@components/setting/TimeControl/NightPlan";

export default {
  name: "Schedule",
  components: {
    MorningPlan,
    MyDialog,
    MidnightPlan,
    NightPlan,
  },
  mixins: [scheduleTool],
  props: {
    selectWeek: {
      type: String,
      default: ""
    },
    isEdit: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  emits: ["closeEditDialog"],
  data() {
    return {
      today: (new Date().getDay() || 7), // 今天的数字 0是周日
      currentEditIdentify: "", // 选中的本周周一
      currentId: 0, // 处理的班次id
      weekNum2Day: {}, // {0:"周一"} , 这种格式
      allUser: [], // 所有的用户
      selectId: [], // 选中的id 存在这个数组, 判断是否重复咯
      selectNames: [], // 下方表示已经选中的名字列表
      department: [], // 所有的用户信息
      persons: [],
      roomOptions: [],
      form: {
        room: ""
      },
      isShowEditDialog: false,
    };
  },
  computed: {
    showSelectNames() {
      // 按照拼音首字母排序
      return this.selectNames.map(item => {
        return item.showName;
      }).sort();
    }
  },
  watch: {
    selectWeek: {
      handler(newVal) {
        if (!newVal) return;
        this.getWeekPlanDetail(newVal);
      },
    }
  },

  mounted() {
    this.getDialogOptionData();
  },
  methods: {
    // 选中的诊室
    changeRoomValue(roomValue) {
      if (!roomValue) {
        // 返回全部
        this.persons = this.allUser;
        return;
      }
      const selectRoomValueList = this.department.find(item => {
        return item.departmenr === roomValue;
      });
      if (!selectRoomValueList) {
        showWindowMessage(3, "没有该科室下的数据", this);
      }
      this.persons = selectRoomValueList.users;
    },
    // 排班设置, 拿到弹窗选项需要的数据
    async getDialogOptionData() {
      const { code, department, scheduling, weekday } = await getDepartUser();
      if (code !== 200) {
        showWindowMessage(3, "获取排班弹窗数据失败, 请重试", this);
        return;
      }
      // debugger
      this.weekNum2Day = weekday;
      department.forEach(({ departmenr, users }) => {
        users.forEach(user => {
          user.value = user.name;
          user.room = departmenr;
        });
      });
      let allUser = [];
      department.forEach(item => {
        allUser = [...allUser, ...item?.users];
      });
      this.allUser = allUser;
      this.persons = allUser;

      this.department = department;
      this.roomOptions = department.map(({ departmenr }) => {
        return {
          label: departmenr,
          value: departmenr
        };
      });
      this.roomOptions.unshift({
        label: "全部",
        value: ""
      });
    },
    /**
     * 弹窗 点击到一个医生
     * @param {number} id - 医生的id
     * */
    clickOne({ id }) {
      // 判断是否已经存起来了
      const isSelectIndex = this.selectId.indexOf(id);
      if (isSelectIndex !== -1) {
        // 已经存在了
        this.selectId.splice(isSelectIndex, 1);
      } else {
        this.selectId.push(id);
      }
      this.selectNames = [];
      this.selectId.forEach(item => {
        const person = this.allUser.find(p => {
          return p.id === item;
        });
        if (person) {
          const temp = {
            id: person.id,
            showName: `${person.room}-${person.value}`
          };
          this.selectNames.push(temp);
        }
      });
    },
    /**
     * @desc 编辑排班弹窗的确定功能
     * @param {boolean} isConfirm - 确定按钮
     * */
    async dealEditDialog(isConfirm) {
      if (isConfirm) {
        const morning_id = this.getAllIds(this.scheduleData, "morning");
        const night_id = this.getAllIds(this.scheduleData, "night");
        const midnight_id = this.getAllIds(this.scheduleData, "midnight");
        const all_id = [...morning_id, ...night_id, ...midnight_id];
        const target = all_id.find(item => {
          return item.id === this.currentId;
        });
        if (!target) {
          showWindowMessage(3, "发生错误, 无法找到对应的信息", this);
          return;
        }
        target.users = this.selectId;
        const data = {
          "scheduling": {
            "1": morning_id,
            "2": night_id,
            "3": midnight_id
          },
          "identify": this.currentEditIdentify
        };
        const { code, msg } = await saveWeekPlan(JSON.stringify(data));
        if (code !== 200) {
          showWindowMessage(3, msg, this);
          return;
        } else {
          showWindowMessage(4, msg, this);
        }
        await this.getWeekPlanDetail(this.selectWeek);
      }

      this.selectNames = [];
      this.selectId = [];
      this.isShowEditDialog = false;
    },

    /**
     * @desc 点击排班的每一个板块, 首先判断是不是可编辑模式, 然后弹窗
     * @param {Object} rooms - 选中的数据
     * @param {string} identify - 本周的周一
     * @param {number} id  - 班次的id
     * */
    clickChange(rooms, identify, id) {
      let time;
      if (this.selectWeek) {
        time = this.selectWeek.split("-")[0].replaceAll(".", "-");
      }
      this.currentEditIdentify = time;
      this.currentId = id;
      if (this.isEdit) {
        if (rooms.length) {
          // room有长度, 代表原来是有人的, 那么就要显示出来
          rooms.forEach(room => {
            const roomName = room.room;
            const roomPersons = room.persons;
            roomPersons.forEach(rp => {
              this.selectId.push(rp.id);
              rp.showName = `${roomName}-${rp.name}`;
            });
            this.selectNames.push(...roomPersons);
          });
        }
        this.isShowEditDialog = true;
      }
    }
  }
};
</script>
<style scoped lang="scss">
::v-deep {
  .el-dialog__body {
    padding: 24px;
  }
}

.schedule {
  display: flex;
}

.day-title {
  height: 64px;
  background: #F4F4F4;
  font-size: 16px;
  color: #999999;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .time {
    font-size: 14px;
    letter-spacing: 2px;
    margin-bottom: 2px;
  }

  .day-date {
    font-size: 20px;
  }
}

.day-events {
  padding-right: 9px;

  .header {
    width: 212px;
    height: 10px;
    border-radius: 10px 10px 0 0;
  }

  ::v-deep .part {
    width: 212px;
    min-height: 150px;
    border-radius: 10px;

    .body {
      padding: 16px 21px 25px 14px;
    }

    .title {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }
  }

  ::v-deep .room {
    > div {
      display: flex;
      margin-bottom: 6px;
    }

    margin-top: 16px;

    .room-name {
      width: 64px;
    }

    .room-person {
      flex: 1;

      span {
        margin-right: 8px;
      }
    }
  }
}

.line-one {
  text-align: left;
  margin-bottom: 20px;

  > span {
    font-size: 16px;
    color: #666666;
    margin-right: 24px;
  }

  .el-select {
    width: 140px;
    height: 32px;

    ::v-deep {
      input {
        height: 32px;
        border: 1px solid #999999;
        border-radius: 10px;
      }

      .el-input__suffix {
        top: -3px;
      }

      .el-input {
        //line-height: 32px;
      }
    }
  }
}

.line-two {
  display: flex;
  background: #F0F5F7;
  padding: 20px;
  height: 168px;
  overflow: auto;
  flex-wrap: wrap;
  align-items: flex-start;
  width: 364px;

  .is-selected {
    font-size: 14px;
    color: #2AA5E3;
  }

  .person {
    cursor: pointer;
    width: 70px;
    text-align: center;

    span {
      font-size: 14px;
    }
  }

  .image-body {
    background: url(../../assets/photos2/user.png) no-repeat center center;
    width: 30px;
    height: 30px;
    margin: auto auto 2px;
  }
}

.is-selected {
  .image-body {
    background: url(../../assets/photos2/user-select.png) no-repeat center center;
  }
}

.line-three {
  margin-top: 20px;
  text-align: left;

  span:nth-child(1) {
    display: inline-block;
    padding-right: 15px;
  }

  span {
    letter-spacing: 2px;
  }
}

.day-title.is-today {
  .time span {
    color: #333333;
    font-weight: bold;
    font-family: Arial, sans-serif;
    letter-spacing: 2px;
    margin-right: 4px;
  }

  .day-week span {
    color: #2AA5E3;
    font-weight: bold;
    font-family: Arial, sans-serif;
  }
}

.day-events {
  .header {
    width: 212px;
    height: 10px;
    border-radius: 10px 10px 0 0;
  }

  color: #CCCCCC;;

  ::v-deep .part .title {
    color: #CCCCCC;;
  }

  .day-morning {
    background: #FFF8EF;

    .header {
      background: #FAE9C7;
    }
  }

  .day-night {
    background: #EEF8FE;

    .header {
      background: #C3E7F9;
    }
  }

  .day-midnight {
    background: #F0F0FE;

    .header {
      background: #D5D6F9;
    }
  }

}

.day-events.is-today {

  color: #333333;

  ::v-deep .part .title {
    color: #333333;
  }

  .day-morning {
    background: #FFEDD5;

    .header {
      background: #FEB832;
    }
  }

  .day-night {
    background: #DAF0FD;

    .header {
      background: #31B8FC;
    }
  }

  .day-midnight {
    background: #e2e2fe;

    .header {
      background: #6A6EDA;
    }
  }
}

</style>
